import { useContext } from "react";
import { GlobalDataContext } from "../context/context";
import TransparentHeader from "../components/global/TransparentHeader";
import BaseLayout from "../components/global/BaseLayout";
import ContentReviews from "../components/reviews/ContentReviews";
// import LoadingSpinner from "../components/global/Loader";
// import { BiLogInCircle } from "react-icons/bi";
// import UserTag from "../components/reviews/userReview";
// import { useSigninCheck } from "reactfire";

function Reviews() {
  const { rpdata } = useContext(GlobalDataContext);

  // const { status, data: signinResult } = useSigninCheck();
  // if (status === "loading") {
  //   return <LoadingSpinner />;
  // }
  // const { signedIn, user } = signinResult;

  return (
    <BaseLayout PageName="Reviews">
      <div className="md:max-w-full w-full">
        <TransparentHeader
          headertitle="Reviews"
          Subheader="Reviews"
          bgimg={`${rpdata?.stock?.[10]}`}
        />
      </div>
      <div className="w-[90%] md:w-4/5 mx-auto py-[100px]">
        <h1 className="text-center pb-4">
          {rpdata?.labels?.general?.titleReviews}
        </h1>
        {
          rpdata?.simpleWidgets?.[4]?.activo ?
            <>

              <ContentReviews />
              <review-widget widgetId="781e8559-576d-4429-a922-9ea916a29e41"></review-widget>

            </>
            : null
        }
      </div>

    </BaseLayout>
  );
}

export default Reviews;